/* =====================================================================
   Extra Elettronica · Motore di valutazione usato a preventivi fissi
   ---------------------------------------------------------------------
   - Nessun calcolo di importi: il prezzo si legge dal listino
     (extra-valuta-regole.js), che ha un valore gia' stabilito per ogni
     modello, memoria e fascia di condizione (A, B, C, D).
   - Ogni risposta con un difetto ha una gravita' (B, C, D) nelle regole
     "patterns". Il difetto piu' grave fissa la fascia e il prezzo del
     listino; ogni altro difetto riduce ancora il prezzo di una quota
     fissa ("extra": B -5%, C -10%, D -15%). Nessuna risposta viene
     ignorata; il prezzo si ferma solo sotto il minimo (rottame).
   - Le risposte "Non lo so" non cambiano il preventivo ma dicono in
     anticipo quale prezzo si applica se al controllo va peggio.
   ===================================================================== */
(function (root) {
  'use strict';

  /* ---------- Modelli e prezzi: stanno nel listino (extra-valuta-regole.js) ---------- */
  var MODELS = [];
  var BRANDS = [
    { id: 'apple', name: 'Apple iPhone' },
    { id: 'samsung', name: 'Samsung Galaxy' },
    { id: 'other', name: 'Altra marca' }
  ];

  /* ---------- Domande (uguali per tutte e tre le direzioni) ---------- */
  // effect: 'manual' = niente preventivo online, si valuta in negozio
  //         'block'  = non possiamo acquistarlo finché la condizione resta
  //         'verify' = non cambia la fascia ora; il listino dice quale fascia vale se al controllo va peggio
  var Q = {
    power: {
      group: 'blocchi', type: 'single',
      q: 'Si accende e funziona normalmente?',
      help: 'Si accende, resta acceso e risponde al tocco.',
      options: [
        { id: 'si', label: 'Sì, funziona' },
        { id: 'no', label: 'No: non si accende, si spegne o si riavvia da solo', effect: 'manual' }
      ]
    },
    account: {
      group: 'blocchi', type: 'single',
      q: { apple: 'Puoi uscire dal tuo ID Apple e disattivare "Dov’è"?', samsung: 'Puoi rimuovere il tuo account Google e il blocco schermo?' },
      help: {
        apple: 'Impostazioni › il tuo nome › Dov’è › Trova il mio iPhone: disattiva. Poi, in fondo, "Esci". Serve la password dell’ID Apple.',
        samsung: 'Impostazioni › Account e backup › Gestisci account › Google › Rimuovi account. Poi togli PIN, sequenza e impronte.',
        other: 'Impostazioni › Account (o Password e account) › Google › Rimuovi account. Poi togli PIN, sequenza e impronte.'
      },
      options: [
        { id: 'si', label: 'Sì, ho le credenziali' },
        { id: 'no', label: 'No, non ho accesso all’account', effect: 'block' }
      ]
    },
    carrier: {
      group: 'blocchi', type: 'single', short: 'Operatore',
      q: 'È bloccato su un operatore telefonico?',
      help: 'Se accetta SIM di qualsiasi operatore italiano, è libero.',
      options: [
        { id: 'no', label: 'No, è libero' },
        { id: 'si', label: 'Sì, funziona solo con un operatore' },
        { id: 'nonso', label: 'Non lo so', effect: 'verify' }
      ]
    },
    screen: {
      group: 'schermo', type: 'single', illustrated: true, short: 'Schermo',
      q: 'In che stato è lo schermo?',
      help: 'Guardalo spento, sotto una luce diretta.',
      options: [
        { id: 'perfetto', label: 'Perfetto', sub: 'Nessun segno, neanche controluce' },
        { id: 'segni', label: 'Segni leggeri', sub: 'Visibili solo controluce, non li senti con l’unghia' },
        { id: 'graffi', label: 'Graffi evidenti', sub: 'Li vedi a schermo acceso o li senti con l’unghia' },
        { id: 'crepato', label: 'Vetro crepato', sub: 'Una o più crepe, anche piccole' },
        { id: 'difetti', label: 'Difetti di visualizzazione', sub: 'Macchie, righe, zone che non rispondono al tocco' }
      ]
    },
    frame: {
      group: 'scocca', type: 'single', illustrated: true, short: 'Bordi e scocca',
      q: 'Bordi e scocca',
      options: [
        { id: 'nuova', label: 'Come nuovi' },
        { id: 'segni', label: 'Segni d’uso leggeri' },
        { id: 'ammaccature', label: 'Ammaccature o vernice saltata' },
        { id: 'piegato', label: 'Piegato o deformato', sub: 'Appoggiato sul tavolo, dondola', effect: 'manual' }
      ]
    },
    back: {
      group: 'scocca', type: 'single', short: 'Vetro posteriore',
      q: 'Vetro posteriore',
      options: [{ id: 'integro', label: 'Integro' }, { id: 'crepato', label: 'Crepato' }]
    },
    lens: {
      group: 'scocca', type: 'single', short: 'Lenti',
      q: 'Lenti delle fotocamere',
      options: [{ id: 'integre', label: 'Integre' }, { id: 'crepata', label: 'Almeno una crepata' }]
    },
    battery: {
      group: 'batteria', type: 'single', short: 'Batteria',
      q: 'Stato della batteria',
      help: {
        apple: 'Impostazioni › Batteria › Stato della batteria › Capacità massima.',
        samsung: 'App Samsung Members › Diagnostica › Stato batteria, oppure chiedi a noi in negozio.',
        other: 'Impostazioni › Batteria › Stato della batteria (non tutti i modelli lo mostrano): se non lo trovi scegli "Non lo so".'
      },
      options: [
        { id: '85', label: '85% o più' },
        { id: '80', label: 'Tra 80% e 84%' },
        { id: 'sotto', label: 'Sotto l’80% o "Assistenza"' },
        { id: 'nonso', label: 'Non lo so', sub: 'La misuriamo noi in ispezione', effect: 'verify' }
      ]
    },
    parts: {
      group: 'batteria', type: 'multi', platform: 'apple', short: 'Parte non originale',
      q: 'In Impostazioni compare un avviso "parte sconosciuta" o "non originale"?',
      help: 'Impostazioni › Generali › Info › Parti e cronologia. Puoi indicarne più di una.',
      options: [
        { id: 'nessuno', label: 'Nessun avviso', exclusive: true },
        { id: 'batteria', label: 'Batteria' },
        { id: 'display', label: 'Schermo' },
        { id: 'fotocamera', label: 'Fotocamera' },
        { id: 'nonso', label: 'Non lo so', exclusive: true, effect: 'verify' }
      ]
    },
    faults: {
      group: 'funzioni', type: 'multi', short: 'Non funziona',
      q: 'Qualcosa non funziona?',
      help: 'Seleziona tutto ciò che hai notato.',
      options: [
        { id: 'ok', label: 'Funziona tutto', exclusive: true },
        { id: 'biometria', label: { apple: 'Face ID o Touch ID', samsung: 'Impronta o riconoscimento del volto', other: 'Impronta o sblocco con il volto' } },
        { id: 'fotocamere', label: 'Fotocamere', sub: 'Foto sfocate, macchie, non si avvia' },
        { id: 'audio', label: 'Altoparlante o microfono' },
        { id: 'ricarica', label: 'Ricarica o connettore' },
        { id: 'tasti', label: 'Tasti' },
        { id: 'rete', label: 'Rete, Wi-Fi o Bluetooth' }
      ]
    },
    liquid: {
      group: 'funzioni', type: 'single', short: 'Contatto con liquidi',
      q: 'È mai entrato in contatto con acqua o altri liquidi?',
      options: [
        { id: 'no', label: 'No' },
        { id: 'si', label: 'Sì' },
        { id: 'nonso', label: 'Non lo so', effect: 'verify' }
      ]
    },
    extras: {
      group: 'dotazione', type: 'multi', optional: true,
      q: 'Cosa ci consegni insieme al telefono?',
      help: 'Facoltativo: non cambia il preventivo. La prova d’acquisto aiuta a dimostrare la provenienza.',
      options: [
        { id: 'scatola', label: 'Scatola originale' },
        { id: 'caricatore', label: 'Cavo o caricatore originale' },
        { id: 'scontrino', label: 'Scontrino o fattura' },
        { id: 'niente', label: 'Solo il telefono', exclusive: true }
      ]
    }
  };

  var GROUPS = [
    { id: 'blocchi', title: 'Accensione e blocchi', short: 'Blocchi', qs: ['power', 'account', 'carrier'],
      intro: 'Tre controlli che decidono se possiamo darti un preventivo online.' },
    { id: 'schermo', title: 'Schermo', short: 'Schermo', qs: ['screen'] },
    { id: 'scocca', title: 'Scocca, retro e fotocamere', short: 'Scocca', qs: ['frame', 'back', 'lens'] },
    { id: 'batteria', title: 'Batteria', short: 'Batteria', qs: ['battery', 'parts'] },
    { id: 'funzioni', title: 'Funzioni', short: 'Funzioni', qs: ['faults', 'liquid'] },
    { id: 'dotazione', title: 'Cosa includi', short: 'Dotazione', qs: ['extras'] }
  ];

  /* ---------- Regole (tutte modificabili dal pannello staff) ---------- */
  var RULES = {};
  /* ---------- utilità ---------- */
  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function label(v, brand) { return (v && typeof v === 'object') ? (v[brand] || (brand === 'other' ? v.samsung : null) || v.apple) : v; }
  function modelById(rules, id) { for (var i = 0; i < rules.models.length; i++) if (rules.models[i].id === id) return rules.models[i]; return null; }
  function questionsFor(brand) {
    var out = [];
    GROUPS.forEach(function (g) {
      g.qs.forEach(function (qid) {
        var q = Q[qid];
        if (q.platform && q.platform !== brand) return;
        out.push(qid);
      });
    });
    return out;
  }
  function groupsFor(brand) {
    return GROUPS.map(function (g) {
      return { id: g.id, title: g.title, short: g.short, intro: g.intro, qs: g.qs.filter(function (qid) { return !Q[qid].platform || Q[qid].platform === brand; }) };
    });
  }
  function isAnswered(q, a) {
    if (a == null) return false;
    if (Array.isArray(a)) return a.length > 0;
    return true;
  }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  var ORDER = ['A', 'B', 'C', 'D'];
  function worse(a, b) { return ORDER.indexOf(b) > ORDER.indexOf(a) ? b : a; }
  function grade(rules, id) { for (var i = 0; i < rules.grades.length; i++) if (rules.grades[i].id === id) return rules.grades[i]; return { id: id, name: id }; }
  /* prezzo con piu' difetti: il piu' grave fissa la fascia (prezzo del listino), ogni altro
     difetto riduce ancora del suo "extra" (mai meno di 1 euro a ogni passo, cosi' scende sempre).
     Si ferma solo sotto il minimo: null = valore da rottame, si valuta in negozio. */
  var SEV = { B: 1, C: 2, D: 3 };
  function sortDefects(list) {
    return list.map(function (d, i) { return { d: d, i: i }; })
      .sort(function (a, b) { return (SEV[b.d.grade] - SEV[a.d.grade]) || (a.i - b.i); })
      .map(function (x) { return x.d; });
  }
  function priceWith(p, list, rules) {
    if (!list.length) return { price: p.A, steps: [] };
    var sorted = sortDefects(list), min = rules.minOffer || 0, extra = rules.extra || { B: 0.95, C: 0.90, D: 0.85 };
    var cur = p[sorted[0].grade], steps = [{ defect: sorted[0], kind: 'base', price: cur == null || cur < min ? null : cur }];
    if (cur == null || cur < min) return { price: null, steps: steps };
    for (var i = 1; i < sorted.length; i++) {
      var f = extra[sorted[i].grade] || 1, next = Math.min(Math.floor(cur * f), cur - 1);
      cur = next < min ? null : next;
      steps.push({ defect: sorted[i], kind: 'extra', pct: Math.round((1 - f) * 100), price: cur });
      if (cur == null) return { price: null, steps: steps };
    }
    return { price: cur, steps: steps };
  }
  function pricesOf(model, cap) { return model && cap != null ? model.prices[String(cap)] || null : null; }
  /* modelli di una marca, nell'ordine del listino, raggruppati per la tendina */
  function modelsFor(rules, brand) {
    var out = [], idx = {};
    rules.models.forEach(function (m) {
      if (m.brand !== brand) return;
      if (!(m.group in idx)) { idx[m.group] = out.length; out.push({ group: m.group, models: [] }); }
      out[idx[m.group]].models.push(m);
    });
    return out;
  }
  function topPrice(model) { var best = null; model.caps.forEach(function (c) { var v = model.prices[c] && model.prices[c].A; if (v != null && (best == null || v > best)) best = v; }); return best; }

  /* il listino arriva compatto: per ogni memoria [A, B, C, D] */
  function normalize(r) {
    (r.models || []).forEach(function (m) {
      if (!m.caps) m.caps = Object.keys(m.prices || {}).sort(function (a, b) { return a - b; });
      m.caps.forEach(function (c) { var v = m.prices[c]; if (Array.isArray(v)) m.prices[c] = { A: v[0], B: v[1], C: v[2], D: v[3] }; });
    });
    return r;
  }

  /* ---------- preventivo ----------
     quote = { brand, modelId, cap, custom, answers: { qid: optionId | [optionIds] } }
     Il prezzo parte da A: il difetto piu' grave fissa la fascia, gli altri lo riducono ancora.
     Finche' mancano risposte il prezzo e' un "fino a": puo' solo scendere. */
  function estimate(quote, rules, opts) {
    opts = opts || {};
    var res = { status: 'incomplete', grade: null, gradeName: '', gradeDesc: '', offer: null, base: null, lo: null, hi: null, table: [], reasons: [], risks: [],
      blocks: [], manual: [], lines: [], answered: 0, total: 0, bonus: 0, low: false, modelName: '', capLabel: '' };
    if (!quote || !quote.brand) return res;
    if (quote.custom) { res.status = 'unsupported'; res.reason = 'custom'; return res; }
    var model = modelById(rules, quote.modelId);
    if (!model) return res;
    res.modelName = model.name;
    var p = pricesOf(model, quote.cap);
    if (!p) return res;
    res.capLabel = capLabel(quote.cap); res.base = p.A;
    res.table = rules.grades.map(function (g) { return { id: g.id, name: g.name, desc: g.desc, price: p[g.id] }; });

    var qids = questionsFor(model.brand), answers = quote.answers || {}, defects = [], verifies = [];
    qids.forEach(function (qid) {
      var q = Q[qid], a = answers[qid];
      if (!q.optional) res.total++;
      if (!isAnswered(q, a)) return;
      if (!q.optional) res.answered++;
      (Array.isArray(a) ? a : [a]).forEach(function (oid) {
        var o = q.options.filter(function (x) { return x.id === oid; })[0];
        if (!o) return;
        var key = qid + '.' + oid, txt = label(o.label, model.brand);
        if (o.effect === 'manual') res.manual.push({ qid: qid, key: key, label: txt });
        if (o.effect === 'block') res.blocks.push({ qid: qid, key: key, label: txt });
        var pg = rules.patterns[key];
        if (pg) defects.push({ qid: qid, key: key, label: (q.short ? q.short + ': ' : '') + txt.charAt(0).toLowerCase() + txt.slice(1), grade: pg });
        var v = rules.verify[key];
        if (v) verifies.push({ qid: qid, key: key, label: v.label, grade: v.grade });
      });
    });
    var calc = priceWith(p, defects, rules), g = defects.length ? sortDefects(defects)[0].grade : 'A';
    res.grade = g; res.gradeName = grade(rules, g).name; res.gradeDesc = grade(rules, g).desc;
    res.offer = calc.price;
    res.defects = sortDefects(defects).length;
    // motivi, dal piu' grave; ogni riga dice quanto pesa
    res.reasons = calc.steps.map(function (s) { return { qid: s.defect.qid, key: s.defect.key, label: s.defect.label, grade: s.defect.grade, kind: s.kind, pct: s.pct || 0, price: s.price }; });
    // "Non lo so": prezzo che si applicherebbe se il controllo confermasse il difetto (sopra quelli gia' indicati)
    res.risks = verifies.map(function (r) {
      var to = worse(g, r.grade), pr = priceWith(p, defects.concat([{ grade: r.grade }]), rules);
      return { qid: r.qid, key: r.key, label: r.label, grade: to, gradeName: grade(rules, to).name, price: pr.price };
    });
    res.hi = res.offer;
    var all = priceWith(p, defects.concat(verifies.map(function (r) { return { grade: r.grade }; })), rules).price;
    res.lo = verifies.length ? (all == null ? 0 : all) : res.offer;
    res.lines = res.reasons.map(function (r) { return { key: r.key, label: r.label, kind: r.kind, grade: r.grade, pct: r.pct, price: r.price }; });
    res.status = isComplete(quote, rules) ? 'ok' : 'partial';
    if (res.blocks.length) res.status = 'blocked';
    else if (res.manual.length) res.status = 'manual';
    else if (res.status === 'ok' && res.offer == null) { res.status = 'low'; res.low = true; }

    // bonus permuta: solo se l'azienda lo attiva
    if (rules.tradeInBonus && rules.tradeInBonus.enabled && res.offer) {
      var b = rules.tradeInBonus;
      res.bonus = Math.round(Math.min(b.type === 'pct' ? res.offer * b.value : b.value, b.cap));
    }
    res.validDays = rules.validityDays;
    if (opts.now) res.validUntil = addDays(opts.now, rules.validityDays).toISOString();
    return res;
  }

  function isComplete(quote, rules) {
    var model = modelById(rules, quote.modelId);
    if (!model) return false;
    return questionsFor(model.brand).every(function (qid) { return Q[qid].optional || isAnswered(Q[qid], (quote.answers || {})[qid]); });
  }
  function missing(quote, rules) {
    var model = modelById(rules, quote.modelId);
    if (!model) return [];
    return questionsFor(model.brand).filter(function (qid) { return !Q[qid].optional && !isAnswered(Q[qid], (quote.answers || {})[qid]); });
  }
  function capLabel(c) { c = +c; return c >= 1024 ? (c / 1024) + ' TB' : c + ' GB'; }

  /* selezione multipla con opzioni esclusive */
  function toggleMulti(q, current, oid) {
    current = Array.isArray(current) ? current.slice() : [];
    var opt = q.options.filter(function (o) { return o.id === oid; })[0];
    var i = current.indexOf(oid);
    if (i >= 0) { current.splice(i, 1); return current; }
    if (opt && opt.exclusive) return [oid];
    current = current.filter(function (id) { var o = q.options.filter(function (x) { return x.id === id; })[0]; return !(o && o.exclusive); });
    current.push(oid);
    return current;
  }

  /* ---------- Stati della richiesta ---------- */
  var STATES = {
    bozza: { label: 'Preventivo iniziato', who: 'cliente', step: 0 },
    stimato: { label: 'Preventivo completato', who: 'cliente', step: 1 },
    inviata: { label: 'Richiesta inviata', who: 'cliente', step: 2 },
    in_viaggio: { label: 'Dispositivo in viaggio', who: 'cliente', step: 3 },
    atteso_negozio: { label: 'Atteso in negozio', who: 'cliente', step: 3 },
    ricevuto: { label: 'Dispositivo ricevuto', who: 'staff', step: 4 },
    ispezionato: { label: 'Ispezione completata', who: 'staff', step: 5 },
    offerta_confermata: { label: 'Offerta confermata', who: 'staff', step: 6 },
    offerta_modificata: { label: 'Offerta modificata', who: 'staff', step: 6 },
    accettata: { label: 'Offerta accettata', who: 'cliente', step: 7 },
    rifiutata: { label: 'Offerta rifiutata', who: 'cliente', step: 7 },
    pagamento_emesso: { label: 'Pagamento emesso', who: 'staff', step: 8 },
    credito_emesso: { label: 'Credito emesso', who: 'staff', step: 8 },
    in_restituzione: { label: 'In restituzione', who: 'staff', step: 8 },
    chiusa: { label: 'Richiesta chiusa', who: 'staff', step: 9 },
    valutazione_manuale: { label: 'In valutazione manuale', who: 'staff', step: 2 },
    scaduta: { label: 'Preventivo scaduto', who: 'sistema', step: 1 },
    annullata: { label: 'Annullata', who: 'cliente', step: 9 }
  };
  var TRANSITIONS = {
    inviata: ['in_viaggio', 'atteso_negozio', 'annullata'],
    valutazione_manuale: ['offerta_confermata', 'chiusa'],
    in_viaggio: ['ricevuto'],
    atteso_negozio: ['ricevuto', 'annullata'],
    ricevuto: ['ispezionato'],
    ispezionato: ['offerta_confermata', 'offerta_modificata'],
    offerta_confermata: ['accettata', 'rifiutata'],
    offerta_modificata: ['accettata', 'rifiutata'],
    accettata: ['pagamento_emesso', 'credito_emesso'],
    rifiutata: ['in_restituzione'],
    pagamento_emesso: ['chiusa'],
    credito_emesso: ['chiusa'],
    in_restituzione: ['chiusa']
  };
  function canMove(from, to) { return (TRANSITIONS[from] || []).indexOf(to) >= 0; }

  function newRequestId(now) {
    var d = new Date(now || Date.now());
    var yy = String(d.getFullYear()).slice(2), mm = ('0' + (d.getMonth() + 1)).slice(-2), dd = ('0' + d.getDate()).slice(-2);
    return 'EX-' + yy + mm + dd + '-' + String(Math.floor(1000 + Math.random() * 9000));
  }

  var api = {
    MODELS: MODELS, BRANDS: BRANDS, Q: Q, GROUPS: GROUPS,
    defaultRules: function () { var r = root.EXTRA_VALUTA_RULES ? clone(root.EXTRA_VALUTA_RULES) : clone(RULES); if (!r.models) r.models = clone(MODELS); return normalize(r); },
    estimate: estimate, isComplete: isComplete, missing: missing, questionsFor: questionsFor, groupsFor: groupsFor,
    modelsFor: modelsFor, topPrice: topPrice, pricesOf: pricesOf, grade: grade,
    toggleMulti: toggleMulti, label: label, modelById: modelById, capLabel: capLabel,
    STATES: STATES, TRANSITIONS: TRANSITIONS, canMove: canMove, newRequestId: newRequestId, addDays: addDays, clone: clone
  };
  root.ExtraEngine = api;
  if (typeof module !== 'undefined') module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);